import React from 'react'
import { Button, Checkbox, Flex, Text } from '@radix-ui/themes'

interface VehicleSelectionToolbarProps {
  isSelectionMode: boolean
  selectedCount: number
  totalCount: number
  onToggleSelectionMode: () => void
  onSelectAll: () => void
  onSelectNone: () => void
  onBulkPublish: () => void
  canPublish: boolean
  // NEW: Unpublish functionality
  onBulkUnpublish?: () => void
  canUnpublish?: boolean
  publishedCount?: number // Count of published vehicles in selection
}

const VehicleSelectionToolbar: React.FC<VehicleSelectionToolbarProps> = ({
  isSelectionMode,
  selectedCount,
  totalCount,
  onToggleSelectionMode,
  onSelectAll,
  onSelectNone,
  onBulkPublish,
  canPublish,
  onBulkUnpublish,
  canUnpublish = false,
  publishedCount = 0,
}) => {
  const allSelected = selectedCount === totalCount && totalCount > 0

  return (
    <div className="bg-white border rounded-lg p-4 mb-4 shadow-sm">
      <Flex justify="between" align="center" className="mb-2">
        <Flex align="center" gap="3">
          <Button variant={isSelectionMode ? 'solid' : 'outline'} onClick={onToggleSelectionMode} size="2">
            {isSelectionMode ? <>✕ Cancelar selección</> : 'Seleccionar vehículos'}
          </Button>

          {isSelectionMode && (
            <>
              <Text size="2" color="gray">
                {selectedCount} de {totalCount} seleccionados
              </Text>

              <Flex align="center" gap="2">
                <Checkbox
                  checked={allSelected}
                  onCheckedChange={(checked) => {
                    if (checked) {
                      onSelectAll()
                    } else {
                      onSelectNone()
                    }
                  }}
                />
                <Text size="2">{allSelected ? 'Deseleccionar todos' : 'Seleccionar todos'}</Text>
              </Flex>
            </>
          )}
        </Flex>

        {isSelectionMode && selectedCount > 0 && (
          <Flex gap="2">
            <Button onClick={onBulkPublish} disabled={!canPublish} size="2" variant="solid" color="green">
              ▶ Publicar {selectedCount} vehículo{selectedCount > 1 ? 's' : ''}
            </Button>

            {/* NEW: Unpublish button */}
            {onBulkUnpublish && publishedCount > 0 && (
              <Button onClick={onBulkUnpublish} disabled={!canUnpublish} size="2" variant="solid" color="red">
                ⏸ Despublicar {publishedCount} vehículo{publishedCount > 1 ? 's' : ''}
              </Button>
            )}
          </Flex>
        )}
      </Flex>

      {isSelectionMode && (
        <Text size="1" color="gray">
          Selecciona los vehículos que deseas publicar en lote. Los vehículos se procesarán en segundo plano.
        </Text>
      )}
    </div>
  )
}

export default VehicleSelectionToolbar
